import { render, staticRenderFns } from "./BookingTicketInfo.vue?vue&type=template&id=d119f5ec&scoped=true&"
import script from "./BookingTicketInfo.vue?vue&type=script&lang=js&"
export * from "./BookingTicketInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingTicketInfo.vue?vue&type=style&index=0&id=d119f5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d119f5ec",
  null
  
)

export default component.exports